<template>
  <div class="plan-toolbar">
    <div class="actions">
      <va-button
        v-if="pdf"
        preset="plain"
      >
        <a
          :href="pdf"
          target="_blank"
        ><img
          src="/icons/file-export-solid.svg"
          alt="export"
        ><span>Download the Plan Summary</span></a>
      </va-button>
      <va-button
        v-if="statement"
        preset="plain"
      >
        <a
          :href="statement"
          target="_blank"
        ><img
          src="/icons/file-export-solid.svg"
          alt="export"
        ><span>Download the Plan Statement</span></a>
      </va-button>
      <va-button
        v-if="spd"
        preset="plain"
      >
        <a
          :href="spd"
          target="_blank"
        ><img
          src="/icons/file-export-solid.svg"
          alt="export"
        ><span>Download the Plan Description</span></a>
      </va-button>
      <va-button
        v-if="calendar"
        preset="plain"
      >
        <img
          src="/icons/calendar-solid.svg"
          alt="calendar"
        >
      </va-button>
    </div>
  </div>
</template>

<script>

export default {
  name: "PlanToolbar",

  components: {
  },

  props: {
    date: {
      type: [String, Date],
      required: false,
      default: null,
    },
    pdf: {
      type: String,
      required: false,
      default: null,
    },
    statement: {
      type: String,
      required: false,
      default: null,
    },
    spd: {
      type: String,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      calendar: false,
    }
  },
}
</script>

<style lang="scss" scoped>
@use "../../../scss/_variables.scss";

.plan-toolbar {
  display: flex;
  justify-content: space-between;
  margin: 1rem 0;

  .statement {
    color: variables.$charcoal-tint-50;

    h2 {
      font-size: variables.$text-lg;
      margin-bottom: 0;
    }

    span {
      font-size: variables.$text-base;
      line-height: 1.5;

      &:first-of-type {
        font-weight: 800;
        font-family: variables.$font-secondary;
        margin-right: 0.5rem;
      }
    }
  }

  .actions {
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    flex-wrap: wrap;
    gap: 1.5rem;

    min-width: 130px;

    button {
      height: fit-content;
      padding: 0.25rem;

      img {
        height: 1.4667rem;
      }

      a {
        display: flex;
        align-items: center;
        gap: 4px;
        span {
          font-size: 16px;
        }
      }
    }
  }
}
</style>